import type { SyncStats, SyncStatus } from '@chatapp-inbox/shared';
import { formatDateTime } from './format';

/** Frase de estado (a que o leitor de tela anuncia quando muda). Sem números que mudam a cada consulta. */
export function syncStateSentence(status: SyncStatus): string {
  switch (status.state) {
    case 'idle':
      return 'Nenhuma importação foi feita desde que o servidor foi iniciado.';
    case 'running':
      return status.startedAt
        ? `Importando… Iniciada em ${formatDateTime(status.startedAt)}.`
        : 'Importando…';
    case 'done':
      return status.finishedAt
        ? `Importação concluída em ${formatDateTime(status.finishedAt)}.`
        : 'Importação concluída.';
    case 'error':
      return status.finishedAt
        ? `A importação falhou em ${formatDateTime(status.finishedAt)}.`
        : 'A importação falhou.';
  }
}

/**
 * O servidor devolve só frases genéricas (nunca detalhes internos), e uma delas pode nomear o
 * serviço de mensagens por trás da conexão: a interface não o nomeia, então NÃO mostra o texto do
 * servidor; reconhece o tipo da falha pelas palavras e escreve o seu, com o que fazer a seguir.
 * Frase desconhecida cai no texto geral.
 */
export function syncErrorHelp(message: string | null): string {
  if (message && /credenciais|recus/i.test(message)) {
    return 'O serviço do WhatsApp recusou as credenciais da conexão. Confira os dados da conexão acima, salve e importe de novo.';
  }
  if (message && /indispon/i.test(message)) {
    return 'Não foi possível falar com o serviço do WhatsApp. Veja se o servidor tem acesso à internet e se os dados da conexão estão corretos; depois, tente de novo.';
  }
  return 'Ocorreu um erro dentro do servidor. Tente de novo; se continuar, peça a quem administra o servidor para consultar os registros (logs).';
}

const count = (n: number): string => n.toLocaleString('pt-BR');

/** Contagens legíveis, na ordem em que fazem sentido de ler. */
export function syncStatRows(stats: SyncStats): { label: string; value: string }[] {
  const rows = [
    { label: 'Conversas importadas', value: count(stats.chats) },
    { label: 'Mensagens novas', value: count(stats.messagesCreated) },
    { label: 'Mensagens que já existiam', value: count(stats.messagesKnown) },
    { label: 'Envios reconhecidos', value: count(stats.reconciled) },
  ];
  if (stats.errors > 0) rows.push({ label: 'Conversas com falha', value: count(stats.errors) });
  return rows;
}
